import React from 'react';
import styled from 'styled-components';
import { useDispatch, useSelector } from "react-redux";
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import Header from '../../components/common/header/Header';
import Footer from "../../components/common/Footer";
import LoadingOverlay from 'react-loading-overlay';
import { Redirect, useHistory } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useState } from 'react';
import SrMyCartEmpty from '../../components/sr/SrMyCartEmpty';
import SrMyCartList from '../../components/sr/SrMyCartList';
import SrMyCartBanner from '../../components/common/banner/SrMyCartBanner';
import { groupBy, forEach, remove, concat, findIndex, replace, reduce, sortBy } from 'lodash';
import { removeUserCartProdBrandAction, getUserCartAction, clearUserCartCodeAction, syncUserCartAction, setUserReqProdsListAction } from '../../modules/su/userCartModule';
import CustomTitle from '../../components/common/title/CustomTitle';
import { reqEsItemListAction, reqEsItemListIngAction} from '../../modules/es/esItemModule';
import {isMobileOnly} from 'react-device-detect';
import { getLocalCartSoldInfoAction, setCartCheckInfoAction} from '../../modules/su/userProdModule';
import {Waypoint} from 'react-waypoint'; //for scroll spy
import {Toast, toast} from '../../components/common/noti/Toast';
import { LoginPopupStyles } from '../../components/common/popup/LoginPopup';
import LoginPopup from '../../components/common/popup/LoginPopup';
import Modal from 'react-modal';
import $ from 'jquery';
import style from '../../../node_modules/dom-helpers/cjs/css';
import * as CONSTANTS from '../../lib/util/Constants';
import { MIN_ITEM } from '../../lib/util/Constants';

/**
 * 수납함
 */
const SrMyCartBlock = styled.div`
    ${isMobileOnly?`
        margin: 0 4vw; 
        padding-top: 60px;   
    `:`
        width: 100%;
        margin: 0 auto;
        padding-top: 80px;
    `};
    
    .ea_num {font-weight:700;}
    .info-concurrency-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size:${isMobileOnly? '12px': '14px'};
      position:relative;
      margin-top: ${isMobileOnly? '6px': '12px'};
    }
`;

const SrMyCartHeaderBlock = styled.div`
    ${isMobileOnly?`
        margin: 0;
         
    `:`
        width: 1176px;
        margin: 0 auto;
    `};
    height:${props => props.height2};
    padding-bottom: ${props => props.bottom};
    position:relative;
`;

const SrMyCartHeaderGrayLine = styled.div`
    height: 8px;
    width: 100vw;
    margin-left: -4vw;
    background-color: #ececec;
    border-top: 1px solid #e0e0e0;
`;
const SrMyCartHeaderTitleMBlock = styled.div`
    width: 100vw;
    height: 30px;
    //height: 50px;
    //margin: 0 0 30px;
    //padding: 7px 125px 7px 2px;
    background-color: #ffffff;
    position: relative;
    font-size: 16px;
    font-weight: 500;
    text-align: center;
    color: #111111;
    //line-height: 50px;
    margin-left: -4vw;
`;

const SrMyCartHeaderTitleMBtnBlock = styled.button`
    width: 36px;
    height: 36px;
    position: absolute;
    top: 7px;
    left: 2px;
    background: url(/assets/images/icon/back_btn.svg) center center/auto no-repeat;
`;

const SrMyCartHeaderSpanBlock = styled.div`
    ${isMobileOnly?`
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: normal;
    text-align: left;
    color: #999999;   
    `:`
    margin-left : 39px;
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: left;
    color: #111111;
    `};
`;

const SrMyCartHeaderSpan2Block = styled.div`
    ${isMobileOnly?`
    font-size: 18px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: left;
    color: #111111; 
    width: calc(100% - 120px);  
    `:`
    margin-left : 39px;
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: left;
    color: #111111;
    `};
`;

const SrMyCartHeaderSpan3Block = styled.div`
    ${isMobileOnly?`
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: normal;
    text-align: left;
    color: #999999;   
    `:`
    margin-left : 39px;
    font-size: 22px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2.09;
    letter-spacing: normal;
    text-align: left;
    color: #999999;
    `};

    .num {
        ${isMobileOnly?`
        font-size: 14px;
        font-weight: 600;  
        `:`
        font-size: 24px;
        font-weight: 600;
        `};
        
    }
`;

const SrMyCartHeaderNumSpanBlock = styled.span`
    ${isMobileOnly?`
    font-weight: 600;  
    `:`
    font-size: 34px;
    font-weight: 600;
    `};
`;

const SrMyCartHeaderLineSpanBlock = styled.span`
    ${isMobileOnly?`
    font-size: 18px;  
    `:`
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.44;
    letter-spacing: normal;
    text-align: left;
    color: #111111;
    `};

    
    ::after {
        content: '';
        display: block;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 7px;
        height: ${isMobileOnly? '14px': '20px'};
        background-color: #ffe7ad;
        z-index: -1;
    }
`;

const SrMyCartHeaderLineBlock = styled.div`
    display: inline-block;
    position: relative;
`;
const SrMyCartHeaderNotiBlock = styled.div`
    ${isMobileOnly?`
    font-size: 12px;
    letter-spacing: -0.6px;
    width: calc(100% - 120px);
    margin-top: 10px;
    `:`
    left : 39px;
    bottom : 53px;
    font-size: 14px;
    position: absolute;
    `};

    font-weight: normal;
    line-height: 1.37;
    text-align: left;
    color: #fc1c67;
`;
const InfoPopOverBlock = styled.span`
      .accent {font-weight: bold;}
      
      .fa-question-circle {
          position:relative;
        .info-concurrency {
          display:none; 
          position:absolute;
          background-color:#fff; 
          border:1px solid #999; 
          animation: fadeOut ease 2s;
          right: -23.5px;
          min-width: 408px;
          border-radius: 4px;
          top: 36px;
          //width:100%;
          padding:30px; 
          text-align: left;
          ${isMobileOnly&&`top: 20px; right: 0;`};
          ${isMobileOnly&&`min-width: 78vw; right: 5vw; padding: 15px;`};
          z-index: 99;
            .title {
                font-size: 18px;
                ${isMobileOnly&&`font-size: 16px;`};
                font-weight: 500;
                    ::before {
                        content: '';
                        display: inline-block;
                        width: 24px;
                        height: 30px;
                        margin-right: 10.5px;
                        background: url(/assets/images/icon/cart-info.svg) center center/auto no-repeat;
                        vertical-align: -9px;
                    }
                }
            .lineborder {
                height: 0;
                border-bottom: solid 1px #111111;
                margin-top: 11px;
            }
            .description {
                font-size: 14px;
                font-weight: normal;
                line-height: 1.86;
                color: #33333;
                padding-top: 9.9px;
                letter-spacing: -0.7px;
                .yellowblcok{
                    display: inline-block;
                    position: relative;
                }
                .yelline {
                    background-color: #ffe7ad;
                    /* ::after {
                        content: '';
                        display: block;
                        position: absolute;
                        width: 100%;
                        left: 0;
                        bottom: 7px;
                        height: 11px;
                        background-color: #ffe7ad;
                        z-index: -1;
                    } */
                }
            }
          }

        .infoview  {
            {display:unset; animation: fadeIn ease 1s;} 
        }

        

        @keyframes fadeIn {
        0% {opacity:0;}
        100% {opacity:1;}
        }
        @keyframes fadeOut {
        0% {opacity:1;}
        100% {opacity:0;}
        }
              
    }

`;
const SrMyCartContentsBlock = styled.div`
    padding: 0 0 0 0;
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
`;

const SrMyCartMoreBlock = styled.p`
    text-align: center;
`;

const SrMyCartMoreBtnBlock = styled.button`
    text-align: center;
`;

const SrMyCartRequestContainerBlock = styled.div`
    ${isMobileOnly?`
    height : 70px;
    width: 100vw;
    margin-left: -4vw;
    `:`
    height : 100px;
    width: 100%;
    margin: 0 auto;
    margin-top: 40px;
    `};

    display: ${props => props.display};
    position:relative;
    bottom:0;
    z-index: 10;
`;

const SrMyCartRequestBlock = styled.div`
    ${isMobileOnly?`
    height : 70px;
    width: 100vw;
    left: 0;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    `:`
    height : 100px;
    width: 100vw;
    //min-width: 100%;
    right: 0;
    border-top-left-radius: 20px;
    //min-width : 1176px;
    left: 0px;
    `};
    display: block;
    position:fixed;
    bottom:0;
    z-index: 10;
    background-color: #111111;
    z-index:9;
    
    &.nofixed {
        position:relative;
        //float: right;
        button { font-weight: 600;}
        left: 0px;
  }
`;

const SrMyCartRequestContentsBlock = styled.div`
    ${isMobileOnly?`
    height : 70px;
    width: 100vw;
    margin-left: -4vw;
    `:`
    height : 100px;
    //width: 1176px;
    width: 100vw;
    margin: 0 auto;
    //margin-top: 40px;
    max-width: 1236px;
    `};

    display: ${props => props.display};
    position:relative;
    bottom:0;
    z-index: 10;
`;

const SrMyCartRequestTotalBlcok = styled.div`
    ${isMobileOnly?`
    height : 70px;
    width: 33vw;
    line-height: 70px;
    font-size: 14px;
    font-weight: 500;
    `:`
    height : 100px;
    //width: 230px;
    line-height: 100px;
    font-size: 20px;
    font-weight: 600;
    margin-left: 30px;
    `};
    float: left;
    color: #ffffff;
    text-align: center;
`;

const SrMyCartRequestBtnBlock = styled.button`
    ${isMobileOnly?`
    height : 70px;
    width : 66vw;
    text-align: center;
    float: left;
    `:`
    height : 100px;
    //width : 540px;
    text-align: right;
    padding-right: 30px;
    float: right;
    `};
    
    
    color: #ffc742;
    
`;

const SrMyCartRequestSpanBlock = styled.span`
    ${isMobileOnly?`
    line-height: 70px;
    font-size: 16px;
    `:`
    line-height: 100px;
    font-size: 20px;
    `};
    position: relative;
    
    font-weight: 500;
    color: #ffc742;
    &:after {
        content: '';
        display: block;
        position: absolute;
        width: 0%;
        left: 0;
        top: 24px;
        height: 1px;
        background-color: #ffc742;
        z-index: -1;
        -webkit-transition: width .2s ease-in;
        -o-transition: width .2s ease-in;
        transition: width .2s ease-in;
    }

    &:hover::after {
        width: 100%;
    }

    &.line::after {
        width: 100%;
    }

`;

const SrMyCartLoginBlock = styled.div`
    position:absolute;
    ${isMobileOnly?`
    top : 105px;
    right : 1vw;
    width: 120px;
    `:`
    top : 85px;
    right : 52.9px;
    width: 140px;
    `};
    
    text-align: center;
    //overflow: hidden;

   /*  .wave-first {
        {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120' preserveAspectRatio='none'%3E%3Crect x='0' y='0' width='120' height='120' style='stroke: none; fill: rgb(255,255,0);' /%3E%3Cpath d='M0,24 C20,4 20,44 40,24 C60,4 60,44 80,24 C100,4 100,44 120,24 L120,300 L0,300 Z' style='stroke: none; fill: rgb(255,199,66);'%3E%3C/path%3E%3C/svg%3E");
        animation: wave 20s both infinite linear;}
    }
    .wave-second& {
        {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120' preserveAspectRatio='none'%3E%3Crect x='0' y='0' width='120' height='120' style='stroke: none; fill: rgb(255,255,0);' /%3E%3Cpath d='M0,48 C20,28 20,68 40,48 C60,28 60,68 80,48 C100,28 100,68 120,48 L120,300 L0,300 Z' style='stroke: none; fill: rgb(255,199,66);'%3E%3C/path%3E%3C/svg%3E");
        animation: wave 20s both infinite linear;}
    } 
    .wave-third {
        {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120' preserveAspectRatio='none'%3E%3Crect x='0' y='0' width='120' height='120' style='stroke: none; fill: rgb(255,255,0);' /%3E%3Cpath d='M0,72 C20,52 20,92 40,72 C60,52 60,92 80,72 C100,52 100,92 120,72 L120,300 L0,300 Z' style='stroke: none; fill: rgb(255,199,66);'%3E%3C/path%3E%3C/svg%3E");
        animation: wave 20s both infinite linear;}
    }
    .wave-fourth {
        {background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 120 120' preserveAspectRatio='none'%3E%3Crect x='0' y='0' width='120' height='120' style='stroke: none; fill: rgb(255,255,0);' /%3E%3Cpath d='M0,96 C20,76 20,116 40,96 C60,76 60,116 80,96 C100,76 100,116 120,96 L120,300 L0,300 Z' style='stroke: none; fill: rgb(255,199,66);'%3E%3C/path%3E%3C/svg%3E");
        animation: wave 20s both infinite linear;}
    } */

    @keyframes wave {
        0% {
            background-position: left 0px top 0px;
        }
        100% { 
            background-position: left 1500px top 0px;
        }
    }
`;

const SrMycartLoginBoxblock = styled.div`
    ${isMobileOnly?`
    width : 90px;
    height : 90px;
    margin-left: 15px;
    `:`
    width : 120px;
    height : 120px;
    margin-left: 10px;
    `};
    
    position:relative;
    border-radius: 50%;
`;

const SrMycartLoginBoxblock2 = styled.div`
    ${isMobileOnly?`
    width : 90px;
    height : 90px;
    margin-left: 15px;
    `:`
    width : 120px;
    height : 120px;
    margin-left: 10px;
    `};
    
    position:absolute;
    border-radius: 50%;
    top: 0px;
`;

const SrMyCartLoginBtnBlock = styled.button`
    ${isMobileOnly?`
    width : 90px;
    height : 90px;
    font-size: 15px;
    font-weight: 400;
    `:`
    width : 120px;
    height : 120px;
    font-size: 22px;
    font-weight: 400;
    `};
    background-color:${props => props.board===false && (props.count > 0 ? '#ffc742' :'#f4f4f4')};// #ffc742;
    border-radius: 50%; 
    
    text-align: center;

    border: ${props => props.board===true && 'solid 1.6px #e7e7e7'};
    
`;

const SrMyCartEsNumSpanBlock = styled.span`
    ${isMobileOnly?`
    font-size: 20px;
    font-weight: 500;
    `:`
    font-size: 40px;
    font-weight: 600;
    `};
    
    color: #111111;
`;

const SrMyCartFiveNumSpanBlock = styled.span`
    ${isMobileOnly?`
    font-size: 12px;
    font-weight: normal;
    `:`
    font-size: 20px;
    font-weight: 500;
    `};
    
    color: #666666;
    text-align: center;
`;

const TriTest = styled.div`
    position: relative;
    z-index: 100;
   /* ::before, ::after{
    content: "";
    border-top: 1px solid #999;
    border-right: 1px solid #999;
    height: 15px;
    width: 15px;
    position: absolute;
    -webkit-transform: rotate(-45deg);
    -ms-transform: rotate(-45deg);
    transform: rotate(-45deg);
    top: 43.9px;
    left: 124px;
    z-index: 100;
    background-color: #fff;
   
   } */

    width: 10px;
    height: 2px;
    background: #ffffff;

    position: absolute;
    ${isMobileOnly?`
    bottom: -8px;
    right: 13vw;
    `:`
    bottom: -22px;
    right: 17px;
    `};

    :before {
        content: " ";
        display: block;
        width: 10px;
        height: 1px;
        background: #999999;
        -webkit-transform: rotate(56deg);
        -moz-transform: rotate(56deg);
        -ms-transform: rotate(56deg);
        transform: rotate(56deg);
        position: absolute;
        top: -4px;
        right: -3px;
    }
    :after {
        content: " ";
        display: block;
        width: 10px;
        height: 1px;
        background: #999999;
        -webkit-transform: rotate(-56deg);
        -moz-transform: rotate(-56deg);
        -ms-transform: rotate(-56deg);
        transform: rotate(-56deg);
        position: absolute;
        top: -4px;
        right: 2px;
    }

   @keyframes fadeIn {
    1000% {opacity:0;}
    100% {opacity:1;}
    }
    @keyframes fadeOut {
    1000% {opacity:1;}
    100% {opacity:0;}
    }

`;

const SrMyCartBottomBlock = styled.div`
    margin: 0 auto;
    ${isMobileOnly?`
    margin-top: 40px;
    margin-bottom: 60px;
    `:`
    margin-bottom: 160px;
    `};
    width: 100%;
    max-width: 1176px;
    
    background-color: #f4f4f4;
    padding: 30px 24px 30px 20px;
`;

const SrMyCartBottomtxtBlock = styled.div`
    ${isMobileOnly?`
    line-height: 1.84;
    `:`
    line-height: 1.71;
    `};
    color: #666666;
    font-size: 14px;
    font-weight: normal;
    
    text-align: left;
`;

const SrMyCartRequestLineBlock = styled.div`
    ${isMobileOnly?`
    margin-top: 27px;
    `:`
    margin-top: 42px;
    `};
    width: 0;
    height: 16px;
    border-left: solid 1px #999999;
    float: left;
`;

const SrMyCartBottomBannerBlock = styled.div`
    
    ${isMobileOnly?`
    `:`
    margin: 0 auto;
    width: 1176px;
    `};
`;

const MAX_CNT = CONSTANTS.MAX_RQST_CNT;
const MAX_PROD = CONSTANTS.MAX_PROD;

const SrMyCart = () => {

    const dispatch = useDispatch();
    const [myCartInfo, setMyCartInfo] = useState(null);
    const [showListNum, setShowListNum] = useState(300); // 최초에는 2개만 보여 준다.
    const [isRequst, setIsRequest] = useState(false);
    const [availCnt, setAvailCnt] = useState(CONSTANTS.MAX_RQST_CNT);
    const [brandNum, setBrandNum] = useState(0);
    const [prodNum, setProdNum] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const refBlockReq = useRef(null);
    const history = useHistory();
    const [info, setInfo] = useState(false);
    const refInfo = useRef(null);
    const [txtES, setTxtES] = useState(-1);
    const [openModalLogin, setOpenModalLogin] = useState(false);
    const [fromLoginPU, setFromLoginPU] = useState(false);
    const [brandId30, setBrandId30] = useState(0);
    // const [waveClassName, setWaveClassName] = useState("wave-none");
    const [waveClassName, setWaveClassName] = useState("neowave-10");
    const [over, setOver] = useState(false);

    const { accessToken, cartProdList, updateStatus, getcode, loading,esItems, esItemsCheck, nickname, prodCartCheckInfo, prodCartInputInfo } = useSelector(
        ({ userReducer, userCartReducer, loadingReducer, esItemsReducer, userProdReducer }) => ({
            accessToken: userReducer.accessToken,
            cartProdList: userCartReducer.cartProdList,
            updateStatus: userCartReducer.updateStatus,
            getcode: userCartReducer.getcode,
            loading: loadingReducer['usercart/GET_CART'],
            esItems: esItemsReducer.esItems,
            esIemsCheck: esItemsReducer.esIemsCheck,
            nickname: userReducer.nickname,
            prodCartCheckInfo: userProdReducer.prodCartCheckInfo,
            prodCartInputInfo: userProdReducer.prodCartInputInfo,
        })
    );

    // useEffect(()=>{console.log('@@',esItems,esItemsCheck)},[esItems,esItemsCheck])
    useEffect(() => {
        dispatch(setCurMenuAction('mycart'));
        dispatch(setHeaderTransferAction(false));
        // window.scrollTo(0, 0);
        if (cartProdList === null || cartProdList === undefined) {
            return;
        }

        if (accessToken !== null && isRequst === false) {
            setIsRequest(true);
            dispatch(getUserCartAction());
            if(cartProdList !== null && cartProdList.length > 0){
                //로컬 저장된 상품의 품절 정보 가져오기
                handleLocalCart();
            }
        } else {
            dispatch(clearUserCartCodeAction());
            if (cartProdList.length > 0) {
                /* console.log("cartProdList = " + JSON.stringify(cartProdList))
                // 리스트를 브랜드별로 그룹화
                let resGrpJson = groupBy(cartProdList, (item) => {
                    return item.brnd_id;
                });

                console.log("resGrpJson = " + JSON.stringify(resGrpJson))

                // Json 결과물을 배열로 변경
                var tmpList = [];
                forEach(resGrpJson, (value, key) => {
                    let tmpItem = { 'brnd_id': key, 'list': value };
                    tmpList.push(tmpItem);
                })
                // 현재 정보에 저장
                setMyCartInfo(tmpList); */

                let list = [];

                if(accessToken === null) {
                    let obj = sortBy (cartProdList, (curobj, key) => {
                        return curobj.reg_date;
                    })

                    //console.log("obj = " + JSON.stringify(obj));

                    let rever = obj.reverse();
                    //console.log("rever = " + JSON.stringify(rever));
                    forEach(rever, (curobj, key) => {
                        var group = curobj.brnd_id.toString();
                        var isSet = false;

                        for(var i = 0; i < list.length ; i++) {
                            let brnd_id = list[i].brnd_id;
                            if(brnd_id === group) {
                                isSet = true;
                                list[i].list.push(curobj);
                                break;
                            }
                        }

                        if(isSet === false) {
                            let tmpItem = { 'brnd_id': group, 'list': [] };
                            tmpItem.list.push(curobj);
                            list.push(tmpItem);
                        }
                    })

                } else {
                    forEach(cartProdList, (curobj, key) => {
                        var group = curobj.brnd_id.toString();
                        var isSet = false;

                        for(var i = 0; i < list.length ; i++) {
                            let brnd_id = list[i].brnd_id;
                            if(brnd_id === group) {
                                isSet = true;
                                list[i].list.push(curobj);
                                break;
                            }
                        }

                        if(isSet === false) {
                            let tmpItem = { 'brnd_id': group, 'list': [] };
                            tmpItem.list.push(curobj);
                            list.push(tmpItem);
                        }
                    })
                }

                //console.log("list = " + JSON.stringify(list))
                setMyCartInfo(list);
                //console.log("tmpList = " + JSON.stringify(tmpList))

                //로컬 저장된 상품의 품절 정보 가져오기
                handleLocalCart();
            } else {
                setMyCartInfo(null);
            }
        }

    }, [cartProdList, updateStatus]);

    useEffect(() => {
        //dispatch(reqEsItemListAction()); // 견적정보 get
        dispatch(reqEsItemListIngAction());

        if(history.action === 'PUSH'){
            let checkInfo = [];
            dispatch(setCartCheckInfoAction(checkInfo));
        }
        let tmpList = [];
        dispatch(setUserReqProdsListAction(tmpList));
    },[])

    useEffect(() => {
        // dispatch(reqEsItemListAction()); // 견적정보 get

        if (esItems !== null && esItems !== undefined) {
            const cnt = (MAX_CNT - esItems.length)<0?0:(MAX_CNT - esItems.length)
            try {

                setTxtES(cnt);
                if (esItems[0][0].rqst_status !== '050106') {
                    setAvailCnt(cnt)
                    let msg = cnt;
                    setTxtES(msg)

                    setWaveClassName("neowave-"+msg);
                    // if(msg === 4) {
                    //     setWaveClassName("wave-fourth");
                    // } else if(msg === 3) {
                    //     setWaveClassName("wave-third");
                    // } else if(msg === 2) {
                    //     setWaveClassName("wave-second");
                    // } else if(msg === 1) {
                    //     setWaveClassName("wave-first");
                    // } else {
                    //     setWaveClassName("wave-none");
                    // }
                }

            } catch (e) { }

        }

    }, [esItems, accessToken])

    useEffect(() => {
        let brandId = 0;

        if(prodCartCheckInfo !== null && prodCartCheckInfo !== undefined) {
            let tempCheckInfo = [];
            Object.assign(tempCheckInfo, prodCartCheckInfo);

            //console.log("tempCheckInfo before = " + JSON.stringify(tempCheckInfo))
            remove(tempCheckInfo, (obj) => {
                return (obj.isSoldOut) === (true)
            });

            //console.log("tempCheckInfo = " + JSON.stringify(tempCheckInfo))
            if(tempCheckInfo !== null && tempCheckInfo.length > 0) {
                let resGrpJson = groupBy(tempCheckInfo, (item) => {
                    return item.brnd_id;
                });

                var tmpList = [];
                forEach(resGrpJson, (value, key) => {
                    let tmpItem = { 'brnd_id': key, 'list': value };
                    if(MAX_PROD < value.length) {
                        brandId = key*1;
                    }
                    tmpList.push(tmpItem);
                })

                //console.log("tmpList = " + JSON.stringify(tmpList))

                setBrandNum(tmpList.length);


                let price = 0;
                let prdNum = 0;
                forEach(tempCheckInfo, (curitem) => {
                    price += curitem.es_opt_pirce*1*curitem.qty*1;
                    prdNum += curitem.qty*1;
                });

                setTotalPrice(price);
                setProdNum(prdNum);
            } else {
                setBrandNum(0);
                setProdNum(0);
                setTotalPrice(0);
            }

        } else {
            setBrandNum(0);
            setProdNum(0);
            setTotalPrice(0);
        }

        setBrandId30(brandId);
    },[prodCartCheckInfo])

    useEffect(() => {
        /**
         * Alert if clicked on outside of element
         */
        function handleClickOutside(event) {
            if (refInfo.current && !refInfo.current.contains(event.target)) {
                setInfo(false);
            }
        }

        // Bind the event listener
        document.addEventListener("mousedown", handleClickOutside);
        document.addEventListener("touchstart", handleClickOutside);
        return () => {
            // Unbind the event listener on clean up
            document.removeEventListener("mousedown", handleClickOutside);
            document.removeEventListener("touchstart", handleClickOutside);
        };
    }, [refInfo]);

    useEffect(() => {
        if(accessToken !== null && accessToken.length > 0) {
            if(fromLoginPU === true) {
                //dispatch(reqEsItemListAction()); // 견적정보 get
                dispatch(reqEsItemListIngAction());
            }
            onCloseModalLogin();
        } else {
            setTxtES(-1)
            setProdNum(0);
        }

    }, [availCnt, accessToken]);

    /* useEffect(() => {
        const onScroll = () => {
          if(!isMobileOnly) {
              $('.fixed').css({left: 0 - $(window).scrollLeft()});
              $('.nofixed').css({left: 0 });
          }
        };

        if(!isMobileOnly) {
            $('.fixed').css({left: 0 - $(window).scrollLeft()});
            $('.nofixed').css({left: 0 });
        }

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
      }, []); */
    /* useEffect(() => {
        // function for handling hash change in browser, toggling modal open
        console.log("useHashRouteToggle")
        const handleOnHashChange = () => {
          const isHashMatch = window.location.hash === "#loginModal";
          console.log("window.location.hash = " + window.location.hash)

          if (isHashMatch) {
            //window.location.assign(modalHash); // navigate to same url but with the specified hash
          } else {
            window.location.replace('#'); // remove the hash
            setOpenModalLogin(false);
          }
        };

        // event listener for hashchange event
        window.addEventListener('hashchange', handleOnHashChange);

        return () => window.removeEventListener('hashchange', handleOnHashChange);
      }, []); */

    const handleLocalCart = () => {
        var prdIds = [];
        var optIds = [];

        forEach(cartProdList, (curitem) => {
            let prdId = curitem.prdct_id;
            let optId = curitem.opt_id;
            prdIds = concat(prdIds, prdId);
            optIds = concat(optIds, optId);
        });

        //console.log('prdids = ' + JSON.stringify(prdIds));
        //console.log('optIds = ' + JSON.stringify(optIds));
        let param = "?prdids=" + prdIds + "&optIds=" + optIds;

        dispatch(getLocalCartSoldInfoAction(param));
    }

    const handlerMoerClick = () => {
        // 보여주는 아이템이 2개씩 늘어남
        if (myCartInfo.length > showListNum) {
            let plusnum = Math.min(myCartInfo.length - showListNum, 2);
            setShowListNum(showListNum + plusnum);
        }
    }

    // 브랜드 제거
    const handleAllDeleteBtnClick = (value) => {

        dispatch(removeUserCartProdBrandAction(value));

        // State 값 변경
        remove(myCartInfo, (obj) => {
            return (obj.brnd_id * 1) === (value * 1)
        });

        if (myCartInfo.length === 0) {
            setMyCartInfo(null);
        } else {
            setMyCartInfo(myCartInfo);
        }

        // 로그인 상태라면 서버 sync
        if (accessToken !== null) {
            remove(cartProdList, (obj) => {
                return (obj.brnd_id * 1) === (value * 1);
            })

            dispatch(syncUserCartAction(cartProdList));
        }
    }

    const handleRequest = () => {
        let msg = "";
        let brandid30input = null;

        if(prodCartInputInfo !== null && prodCartInputInfo.length > 0) {

            for(let i = 0; i < prodCartInputInfo.length; i++) {
                let brnd_id = prodCartInputInfo[i].brnd_id;
                let inputRef = prodCartInputInfo[i].inputRef;
                let headRef = prodCartInputInfo[i].headRef
                let idx = findIndex(prodCartCheckInfo, (curitem) => {
                    return (curitem.brnd_id === brnd_id);
                })

                if(idx >= 0 && inputRef.current !== null) {
                    //console.log("input = " + inputRef.current.value);
                    //console.log("brnd_id =" + brnd_id + " headRef = " + headRef.current.offsetTop)
                    if(brandId30*1 === brnd_id*1) {
                        //console.log("brnd_id = " + brnd_id);
                        brandid30input = headRef;
                    }

                    /* const value = inputRef.current.value;
                    if(value !== null) {
                        if(value.length === 0 || value*1 === 0) {
                            msg = "희망견적금액을 입력해주세요.";
                            inputRef.current.focus();
                            break;
                        }
                    } else {
                        msg = "희망견적금액을 입력해주세요.";
                        inputRef.current.focus();
                        break;
                    } */
                }
            }
            //console.log("input = " + inputRef.current.value);
        }
        if (msg.length === 0) {
            if(prodNum < CONSTANTS.MIN_ITEM) {
                msg = `견적은 상품 ${CONSTANTS.MIN_ITEM}개 이상일때 요청 가능합니다.\n상품을 더 추가하셔서 견적을 알아보세요 :-)`
            } else if(brandId30*1 > 0) {
                msg = "한 브랜드의 상품 "+CONSTANTS.MAX_PROD+"개 이하일 때 요청 가능합니다.\n상품을 조금만 덜어서 견적을 알아보세요 :-)"
                //console.log("brandId30 =" + brandId30 + " offsettop = " + brandid30input.current.offsetTop)
                 $('html, body').animate({
                    scrollTop: brandid30input.current.offsetTop - 50
                }, 300, 'swing');

                //brandid30input.current.scrollIntoView({ behavior: 'smooth', block: 'start' });

            } else if(MAX_CNT - availCnt + brandNum > CONSTANTS.MAX_RQST_CNT) {
                //msg = "회원님의 견적 진행 가능한 브랜드 수량은 " + availCnt + "개입니다.\n진행중인 견적서를 확인 후 "+CONSTANTS.MAX_RQST_CNT+"개 이하로 요청주세요."
                msg = "회원님의 견적 브랜드 수량은 " + availCnt + "개입니다.\n나의 견적 횟수를 확인해주세요."
            }
        }

        if (msg.length === 0) {
            if(prodCartInputInfo !== null && prodCartInputInfo.length > 0) {

                for(let i = 0; i < prodCartInputInfo.length; i++) {
                    let brnd_id = prodCartInputInfo[i].brnd_id;
                    let inputRef = prodCartInputInfo[i].inputRef;
                    let headRef = prodCartInputInfo[i].headRef
                    let idx = findIndex(prodCartCheckInfo, (curitem) => {
                        return (curitem.brnd_id === brnd_id);
                    })

                    if(idx >= 0 && inputRef.current !== null) {
                        //console.log("input = " + inputRef.current.value);
                        //console.log("brnd_id =" + brnd_id + " headRef = " + headRef.current.offsetTop)
                        if(brandId30*1 === brnd_id*1) {
                            //console.log("brnd_id = " + brnd_id);
                            brandid30input = headRef;
                        }

                        const value = inputRef.current.value;
                        if(value !== null) {
                            if(value.length === 0 || value*1 === 0) {
                                msg = "희망견적금액을 입력해 주세요.";
                                inputRef.current.focus();
                                break;
                            }
                        } else {
                            msg = "희망견적금액을 입력해 주세요.";
                            inputRef.current.focus();
                            break;
                        }
                    }
                }
                //console.log("input = " + inputRef.current.value);
            }
        }
        //toast('SUCCESS','teststsete');
        if (msg.length > 0) {
            toast('SUCCESS', msg);
            return;
        }

        if(prodCartCheckInfo !== null && prodCartCheckInfo !== undefined) {
            let tempCheckInfo = [];
            var tmpList = [];

            forEach(cartProdList, (prod) => {
                let idx = findIndex(prodCartCheckInfo, (curitem) => {
                    return (curitem.prdct_id === prod.prdct_id && curitem.opt_id === prod.opt_id);
                })

                let list = {};
                Object.assign(list,prod )
                if(idx >= 0) {
                    tempCheckInfo.push(list);
                }
            });

            //console.log("tempCheckInfo = " + JSON.stringify(tempCheckInfo))
            if(tempCheckInfo !== null && tempCheckInfo.length > 0) {
                let resGrpJson = groupBy(tempCheckInfo, (item) => {
                    return item.brnd_id;
                });

                forEach(resGrpJson, (value, key) => {
                    let tmpItem = { 'brnd_id': key, 'list': value };
                    let idx = findIndex(prodCartInputInfo, (curitem) => {
                        return (curitem.brnd_id*1 === key*1);
                    })

                    if(idx >= 0) {
                        let value = prodCartInputInfo[idx].inputRef.current.value;
                        //let price = prodCartInputInfo[idx].inputRef.current.value.replace(",","");
                        let price = replace(prodCartInputInfo[idx].inputRef.current.value, /,/g, "");

                        tmpItem.price = price*1;
                        //console.log('value = ' + value)
                        //console.log('price = ' + price)

                    }
                    tmpList.push(tmpItem);
                })

                //console.log("tmpList = " + JSON.stringify(tmpList))

                dispatch(setUserReqProdsListAction(tmpList));
                history.push('/requestform');
            }
        }
    }

    const getCartList = () => {

        if (loading || myCartInfo === undefined) {
            return <div />;
        } else if (myCartInfo === null || myCartInfo.length === 0) {
            return <SrMyCartEmpty />;
        } else {
            return (
                <SrMyCartList cartProdList={myCartInfo}
                    showItemCnt={showListNum}
                    removeBrand={handleAllDeleteBtnClick} />
            )
        }
    }

    const isMoreBtnShow = () => {
        if (myCartInfo === null ||
            myCartInfo.length === 0 ||
            myCartInfo.length <= showListNum) {
            return false;
        }

        return true;
    }

    const handleLogin = () => {
        if (accessToken === null) {
            onOpenModalLogin();
            setFromLoginPU(true);
        }
    }

    const onOpenModalLogin = () => {
        setOpenModalLogin(true);
        //window.location.assign("#loginModal");
    }

    // Modal 닫기
    const onCloseModalLogin = () => {
        setOpenModalLogin(false);
        setFromLoginPU(false);
        //window.history.back();
    }

    const handleEsInfo = () => {
        setInfo(true);
    }

    const handleMouseEnter = () => {
        setOver(true);
    }

    const handleMouseLeave = () => {
        setOver(false);
    }

    const infoConcurrency = () => {return(
        <InfoPopOverBlock>
            <i className="fas fa-question-circle" onClick={handleEsInfo}>
                {(<div className={info ? "info-concurrency infoview" :"info-concurrency"} ref={refInfo}>
                    <div className="title">견적 안내</div>
                    <div className="lineborder"></div>
                    <div className="description">
                        <p>어디가구에서는 과도한 견적 요청을 막고자</p>
                        <p><div className="yellowblcok"><span className="yelline">동시 <span className="accent">견적 브랜드 수량</span>을 <span className="accent">{MAX_CNT}건</span></span></div>으로 제한하고 있습니다.</p>
                        <p>진행중인 견적 중 최소 한 건 이상 완료시</p>
                        <p>새롭게 견적이 가능하오니 이용에 참고 부탁드립니다.</p>
                     </div>
                </div>)}

            </i>
        </InfoPopOverBlock>)
    }
    const checkAvailCount = () =>{
        return ( <div className="info-concurrency-wrapper">
                    <div className="" style={{ display: accessToken === null ? 'none' : 'block',justifyContent:'center', alignItems:'center' }}>
                    <b className="ea_num">{nickname}</b>님의 현재 <span className="underline">견적 진행 가능 수량은 <b className="ea_num"> {availCnt} </b>개 </span>입니다.
                        &nbsp;&nbsp;{infoConcurrency()}</div></div>);
    };

    const infoBlock = () =>{
        return ( <div className="info-concurrency-wrapper">
                    <div className="" style={{ display: accessToken === null ? 'none' : 'block',justifyContent:'center', alignItems:'center', color:'#333333' }}>
                    <span>나의 견적 횟수 </span>
                        &nbsp;&nbsp;{infoConcurrency()}</div></div>);
    };

    // 카트가 비어 있는 지 확인
    const isCartEmpty = () => {
        return (myCartInfo === null || myCartInfo.length === 0)
    }

    const getBrandProdNum = () => {
        let text = brandNum;
        //console.log("prodNum = " +brandNum )

        return brandNum + "개 브랜드, " + prodNum + "개의 상품을 선택하셨어요.\n" + Number((totalPrice * 1).toFixed(1)).toLocaleString() + "원의 견적금액을 확인하세요"
    }

    const getNotiMsg = () => {
        let text = "";
        if(MAX_CNT - availCnt + brandNum > CONSTANTS.MAX_RQST_CNT) {
            text = "견적 가능한 브랜드 수량은 최대 "+CONSTANTS.MAX_RQST_CNT+"개 입니다."
        } else if(prodNum < CONSTANTS.MIN_ITEM) {
            text = `상품 ${CONSTANTS.MIN_ITEM}개 이상 선택 시 견적 진행이 가능합니다.`;
        }

        return text;
    }

    const checkBottomPosition = (props) => {
         //console.log('check = ',JSON.stringify(props))

        if(props.currentPosition === Waypoint.below && refBlockReq.current) {
            //console.log("nofixed remove")
            //refBlockReq.current.classList.remove('nofixed');
            //refBlockReq.current.classList.add('fixed');
        }
        else if(props.currentPosition === Waypoint.inside && props.previousPosition === Waypoint.below && refBlockReq.current) {
            //console.log("nofixed add")
            //refBlockReq.current.classList.remove('fixed');
            //refBlockReq.current.classList.add('nofixed');
        }
        //console.log('check = ',JSON.stringify(refBlockReq.current.classList))

    }

    const checkEnterBottomPosition = (props) => {
         //console.log('enter = ',JSON.stringify(props))
        //if(props.currentPosition === 'above') refBtnQuote.current.classList.remove('fixed')
        //else if(props.currentPosition === 'inside' && props.previousPosition === 'above') refBtnQuote.current.classList.add('fixed')
    }

    const getLoginBtntext = () => {
        if(accessToken === null) {
            return "로그인"
        } else {
            //console.log("txtES= "+ txtES)
            if(txtES*1 >= 0) {
                //console.log("txtES22= "+ txtES)
                return <SrMyCartEsNumSpanBlock>{txtES}<SrMyCartFiveNumSpanBlock> / {CONSTANTS.MAX_RQST_CNT}</SrMyCartFiveNumSpanBlock></SrMyCartEsNumSpanBlock>
            }
        }
    }

    const getLoginBtnBorder = () => {
        if(accessToken === null) {
            return false;
        } else {
            if(txtES*1 > 0) {
                let count = txtES*1;
                if(count < MAX_CNT && count > 0) {
                    return true;
                }
            }
        }

        return false;
    }

    const getLoginBtnCount = () => {
        if(accessToken === null) {
            return MAX_CNT;
        } else {
            if(txtES*1 > 0) {
                let count = txtES*1;
                if(count <= MAX_CNT && count > 0) {
                    return count;
                }
            }
        }

        return 0;
    }

    const handleBack = () => {
        history.goBack();
    }
    return (
        <SrMyCartBlock>
            <Header />
            <SrMyCartHeaderBlock height2={isCartEmpty()? (isMobileOnly ? '50px' : ''):(isMobileOnly ? '256px' : '') }
                bottom={isCartEmpty()? (isMobileOnly ? '' : '0px'):(isMobileOnly ? '' : '88px') } >
                {isMobileOnly?
                <SrMyCartHeaderTitleMBlock></SrMyCartHeaderTitleMBlock>
                :<CustomTitle title="내가 담은 장바구니"
                marginBottom="90px"
                textColor="#666666" marginTop="76px" fontWeight="300"
                fontSize={isMobileOnly?'22px':'24px'} />}

                <div style={{ display: isCartEmpty() ? 'none' : 'block' }}>
                    <SrMyCartHeaderSpan3Block><span className="num">{brandNum}</span>개 브랜드, <span className="num">{prodNum}</span>개의 상품을 선택했어요.</SrMyCartHeaderSpan3Block>
                    {isMobileOnly?
                    <SrMyCartHeaderSpan2Block><SrMyCartHeaderLineBlock><SrMyCartHeaderLineSpanBlock><SrMyCartHeaderNumSpanBlock>{Number((totalPrice * 1).toFixed(1)).toLocaleString()}</SrMyCartHeaderNumSpanBlock>원의</SrMyCartHeaderLineSpanBlock></SrMyCartHeaderLineBlock><br/>견적금액을 알아보세요.</SrMyCartHeaderSpan2Block>
                    :
                    <SrMyCartHeaderSpanBlock><SrMyCartHeaderLineBlock><SrMyCartHeaderLineSpanBlock><SrMyCartHeaderNumSpanBlock>{Number((totalPrice * 1).toFixed(1)).toLocaleString()}</SrMyCartHeaderNumSpanBlock>원의 견적금액</SrMyCartHeaderLineSpanBlock></SrMyCartHeaderLineBlock>을 알아보세요.</SrMyCartHeaderSpanBlock>}

                </div>
                <SrMyCartHeaderNotiBlock style={{ display: isCartEmpty() || getNotiMsg().length < 1 ? 'none' : 'block' }}>
                    {getNotiMsg()}
                </SrMyCartHeaderNotiBlock>
                {/* {checkAvailCount()} */}
                <SrMyCartLoginBlock style={{ display: isCartEmpty() ? 'none' : 'block' }}>
                    <SrMycartLoginBoxblock2 className={waveClassName+'-add1'}> </SrMycartLoginBoxblock2>
                    <SrMycartLoginBoxblock2 className={waveClassName+'-add2'}> </SrMycartLoginBoxblock2>
                    <SrMycartLoginBoxblock className={waveClassName}><SrMyCartLoginBtnBlock  onClick={handleLogin} board={getLoginBtnBorder()} count={getLoginBtnCount()}>{getLoginBtntext()}</SrMyCartLoginBtnBlock> </SrMycartLoginBoxblock>

                    <TriTest style={info? {display: "block", animation:"fadeIn ease 1s" }:{display:"none"}}></TriTest>
                    {infoBlock()}

                </SrMyCartLoginBlock>
            </SrMyCartHeaderBlock>
            {isMobileOnly&&<SrMyCartHeaderGrayLine style={{display: isCartEmpty()? 'none':'block'}}/>}

            <SrMyCartContentsBlock>
                {getCartList()}
                {isMoreBtnShow() ?
                    <SrMyCartMoreBlock>
                        <SrMyCartMoreBtnBlock onClick={handlerMoerClick}>더보기
                    </SrMyCartMoreBtnBlock>
                    </SrMyCartMoreBlock> : ''
                }
            </SrMyCartContentsBlock>
            {isMobileOnly ? '' :
            <SrMyCartRequestContainerBlock display={ prodNum > 0 ? 'none' : 'block'  }/>
            }
            {isMobileOnly ? '' :
            <SrMyCartRequestContainerBlock display={ prodNum > 0 ? 'block' : 'none'  }>

                <SrMyCartRequestBlock ref={refBlockReq} className="fixed">
                    <SrMyCartRequestContentsBlock>
                        <SrMyCartRequestTotalBlcok>{Number((totalPrice * 1).toFixed(1)).toLocaleString()}<span style={isMobileOnly? {fontSize:'14px', fontWeight:'normal'}:{fontSize:'18px', fontWeight:'normal'}}>원</span></SrMyCartRequestTotalBlcok>
                        {/* <SrMyCartRequestLineBlock/> */}
                        <SrMyCartRequestBtnBlock onClick={handleRequest} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                            <SrMyCartRequestSpanBlock className={over? "line" : ""}><span style={isMobileOnly ? {fontSize:'18px', fontWeight:'bold'}:{fontSize:'22px', fontWeight:'600'}}>{prodNum}</span>개 견적 알아보기</SrMyCartRequestSpanBlock>
                        </SrMyCartRequestBtnBlock>
                    </SrMyCartRequestContentsBlock>
                </SrMyCartRequestBlock>

            </SrMyCartRequestContainerBlock>
            }
            {isMobileOnly ? '' :
            <Waypoint onPositionChange={(props)=>checkBottomPosition(props)} fireOnRapidScroll></Waypoint>
            }


            <SrMyCartBottomBlock>
                <SrMyCartBottomtxtBlock style={{color: '#333333'}}>• 장바구니에 담긴 상품은 {CONSTANTS.MAX_CART_PERIOD} 동안 보관됩니다.</SrMyCartBottomtxtBlock>
                <SrMyCartBottomtxtBlock>• 1개월이 지난 상품은 자동 삭제됩니다.</SrMyCartBottomtxtBlock>
                <SrMyCartBottomtxtBlock>• 장바구니에 최대 {CONSTANTS.MAX_CART_CNT}개까지 상품 보관이 가능하며, 실제 주문 시에는 가격이 변동될 수 있습니다.</SrMyCartBottomtxtBlock>
                <SrMyCartBottomtxtBlock>• 장바구니에 담은 상품은 판매종료가 되었을 경우 자동 삭제됩니다.</SrMyCartBottomtxtBlock>
            </SrMyCartBottomBlock>


            {isMobileOnly ?
            <SrMyCartRequestContainerBlock display={ prodNum > 0 ? 'block' : 'none'  }>
            <SrMyCartRequestBlock ref={refBlockReq} >
                <SrMyCartRequestTotalBlcok>{Number((totalPrice * 1).toFixed(1)).toLocaleString()}<span style={isMobileOnly? {fontSize:'14px', fontWeight:'normal'}:{fontSize:'18px', fontWeight:'normal'}}>원</span></SrMyCartRequestTotalBlcok>
                <SrMyCartRequestLineBlock/>
                <SrMyCartRequestBtnBlock onClick={handleRequest} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    <SrMyCartRequestSpanBlock className={over? "line" : ""}><span style={isMobileOnly ? {fontSize:'18px', fontWeight:'bold'}:{fontSize:'22px', fontWeight:'600'}}>{prodNum}</span>개 견적 알아보기</SrMyCartRequestSpanBlock>
                </SrMyCartRequestBtnBlock>
            </SrMyCartRequestBlock>
            </SrMyCartRequestContainerBlock>
             : ''}
            {isMobileOnly ? <Waypoint onPositionChange={(props)=>checkBottomPosition(props)} fireOnRapidScroll></Waypoint>
            : '' }

            <Toast/>
            <SrMyCartBottomBannerBlock><SrMyCartBanner /></SrMyCartBottomBannerBlock>

            <Footer siteMovePosition={isMobileOnly?'80px':'110px'} />
            {prodNum > 0&&<div className="margin_b-50">&nbsp;</div>}
            <Modal
                isOpen={openModalLogin}
                onRequestClose={onCloseModalLogin}
                style={LoginPopupStyles}
                onAfterOpen={() => document.body.style.overflow = 'hidden'}
                onAfterClose={() => document.body.removeAttribute('style')}>
                <LoginPopup onClosePopup={onCloseModalLogin}/>
            </Modal>
        </SrMyCartBlock>
    );
};

export default SrMyCart;
